export default __webpack_public_path__ + "images/fileuploaded.png";